import Cookies from "js-cookie";
import {
  makeRequestDelete2,
  makeRequestGet2,
  makeRequestPost2,
  makeRequestPut2,
} from "../api";

function getToken() {
  return new Promise((resolve) => {
    const checkToken = () => {
      let token = Cookies.get("token");
      if (token) {
        resolve(token);
      } else {
        setTimeout(checkToken, 100); // Check again after 100ms
      }
    };
    checkToken();
  });
}

export async function getFederations() {
  let token = await getToken();
  return makeRequestGet2(`owners/federations/`, token);
}

export async function getFederation(id) {
  let token = await getToken();
  return makeRequestGet2(`owners/${id}`, token);
}

export async function postFederation(data) {
  let token = await getToken();
  return makeRequestPost2(`owners/`, data, token);
}

export async function putFederation(id, data) {
  let token = await getToken();
  return makeRequestPut2(`owners/${id}`, data, token);
}

export async function deleteFederation(id, data) {
  let token = await getToken();
  return makeRequestDelete2(`owners/${id}`, data, token);
}
